<header>
  <a
    [routerLink]="['/user/hello']"
    fxLayout
    fxLayoutAlign="center center"
    fxLayoutAlign.lt-md="start center"
    fxLayoutGap="8px">
    <img class="sbnb-logo" src="/assets/images/logo-transparent-dark.svg" alt="Hospitable logo" />
  </a>
  <div class="navigation">
    <a (click)="gotoPrev()" *ngIf="hasPrev() && !hideActions" class="back-button" fxLayoutAlign="center center">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 8H1" stroke="#B3AFBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M8 15L1 8L8 1" stroke="#B3AFBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </a>
    <sbnb-close [border]="true" *ngIf="!hideActions" (click)="cancelWizard()"></sbnb-close>
  </div>
</header>
